import { enUS } from "./enUS";
import { esCO } from "./esCO";
export const languages = {
    'es-CO': esCO,
    'en-US': enUS
};
